'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.ticketFilter = twentyninetimes.ticketFilter || function () {

    function init() {
        const ticketFilter = document.getElementById('js-ticket-filter');
        if ( ticketFilter ) {
          filters();
        }
    }

    function filters() {
        const filterButtons = document.querySelectorAll('[data-filter-category]');
        const categorySections = document.querySelectorAll('[data-list-category]');
        let selectedCategories = [];

        filterButtons.forEach(button => {
            button.addEventListener('click', function () {
                const category = this.getAttribute('data-filter-category');

                // Handle "Show All" button
                if (category === 'all') {
                    selectedCategories = [];
                    categorySections.forEach(section => section.style.display = 'block');
                    updateSelectedCategories();
                    filterButtons.forEach(btn => btn.classList.remove('active')); // Remove 'active' class from all buttons
                    this.classList.add('active'); // Add 'active' class to "Show All" button
                } else {
                    // Toggle category selection
                    if (selectedCategories.includes(category)) {
                        selectedCategories = selectedCategories.filter(cat => cat !== category);
                        this.classList.remove('active'); // Remove 'active' class
                    } else {
                        selectedCategories.push(category);
                        this.classList.add('active'); // Add 'active' class
                    }

                    // Filter categories
                    filterCategories();
                }
            });
        });

        function filterCategories() {
            if (selectedCategories.length === 0) {
                // Show all categories if no category is selected
                categorySections.forEach(section => section.style.display = 'block');
            } else {
                // Show only the selected categories
                categorySections.forEach(section => {
                    const sectionCategory = section.getAttribute('data-list-category');
                    if (selectedCategories.includes(sectionCategory)) {
                        section.style.display = 'block';
                    } else {
                        section.style.display = 'none';
                    }
                });
            }
        }
    }

    return {
        init: init
    };

}();